// the enquiry variables provide a maintainable way of modifying the enquiry
// form and conditionaly dispaying the correct enquiryTypes and subTypes
// depending on Network and subsequent selections

const enquiryEmails = [
  'MDP-CP@powercor.com.au',
  'MDP-PAL@powercor.com.au',
  'ConnectionServicesEnquiries@powercor.com.au ',
  'LNSP-CP@powercor.com.au',
  'LNSP-PAL@powercor.com.au',
  'ConnectionServicesEnquiries@powercor.com.au',
  'B2B-SO-PAL@powercor.com.au',
  'sreadingskilltech@powercor.com.au',
  'B2B-SO-PAL@powercor.com.au',
];

const enquiryTeams = [
  'Meter Data and Interface',
  'Connections',
  'Customer energisation',
];

const enquiryTypes = [
  'Meter related',
  'NMI standing data',
  'Service order related',
  'Energisation / Special Read',
  'MSATS',
  'Embedded networks',
  'Customer detail or site access',
  'Other',
];

export const enquirySubtypes = [
  {
    label: 'Meter usage',
    type: enquiryTypes[0],
    network: ['CitiPower'],
    team: enquiryTeams[0],
    email: enquiryEmails[0],
    description: 'Queries relating to actual data for a meter',
  },
  {
    label: 'Meter usage',
    type: enquiryTypes[0],
    network: ['Powercor'],
    team: enquiryTeams[0],
    email: enquiryEmails[1],
    description: 'Queries relating to actual data for a meter',
  },
  {
    label: 'Substituted data',
    type: enquiryTypes[0],
    network: ['CitiPower'],
    team: enquiryTeams[0],
    email: enquiryEmails[0],
    description: 'Queries relating to reason for substituted/estimated data',
  },
  {
    label: 'Substituted data',
    type: enquiryTypes[0],
    network: ['Powercor'],
    team: enquiryTeams[0],
    email: enquiryEmails[1],
    description: 'Queries relating to reason for substituted/estimated data',
  },
  {
    label: 'MRIM to AMI meter conversion',
    type: enquiryTypes[0],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Converting MRIM to AMI, smart meter installation',
  },
  {
    label: 'Data stream mismatch',
    type: enquiryTypes[0],
    network: ['CitiPower'],
    team: enquiryTeams[0],
    email: enquiryEmails[3],
    description: '',
  },
  {
    label: 'Data stream mismatch',
    type: enquiryTypes[0],
    network: ['Powercor'],
    team: enquiryTeams[0],
    email: enquiryEmails[4],
    description: '',
  },
  {
    label: 'Transposition/Crossed Meter',
    type: enquiryTypes[0],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Relates to incorrect metering or supply address',
  },
  {
    label: 'Supply address update',
    type: enquiryTypes[1],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Updating the supply address in MSATS',
  },
  {
    label: 'NMI discovery/NMI status G',
    type: enquiryTypes[1],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Locating the NMI number in MSATS',
  },
  {
    label: 'NMI status A',
    type: enquiryTypes[1],
    network: ['CitiPower'],
    team: enquiryTeams[0],
    email: enquiryEmails[3],
    description: 'Queries related to active status in MSATS',
  },
  {
    label: 'NMI status A',
    type: enquiryTypes[1],
    network: ['Powercor'],
    team: enquiryTeams[0],
    email: enquiryEmails[4],
    description: 'Queries related to active status in MSATS',
  },
  {
    label: 'NMI status D',
    type: enquiryTypes[1],
    network: ['CitiPower'],
    team: enquiryTeams[0],
    email: enquiryEmails[3],
    description: 'Queries related to deactivated status in MSATS',
  },
  {
    label: 'NMI status D',
    type: enquiryTypes[1],
    network: ['Powercor'],
    team: enquiryTeams[0],
    email: enquiryEmails[4],
    description: 'Queries related to deactivated status in MSATS',
  },
  {
    label: 'NMI status X',
    type: enquiryTypes[1],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Abolishment request with incorrect NMI status in MSATS',
  },
  {
    label: 'Disaggregation request',
    type: enquiryTypes[1],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Separating meters from a site that has mutltiple meters',
  },
  {
    label: 'NMI class classification domestic/commercial',
    type: enquiryTypes[1],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Changing sites from domestic to commercial and vice versa',
  },
  {
    label: 'NMI Classification Small/Large',
    type: enquiryTypes[1],
    network: ['CitiPower'],
    team: enquiryTeams[0],
    email: enquiryEmails[3],
    description: 'Requesting NMI classification change due to change in usage',
  },
  {
    label: 'NMI Classification Small/Large',
    type: enquiryTypes[1],
    network: ['Powercor'],
    team: enquiryTeams[0],
    email: enquiryEmails[4],
    description: 'Requesting NMI classification change due to change in usage',
  },
  {
    label: 'Solar reconfiguration',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Updating meter to record solar usage',
  },
  {
    label: 'Notice of Metering Works',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description:
      'Use for connection works when Citipower & Powercor are not the meter provider',
  },
  {
    label: 'Meter Investigation',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Used for meter test service orders',
  },
  {
    label: 'Allocate NMI',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Queries related to the NMI assigned to the supply address',
  },
  {
    label: 'Supply service works',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Status updates/Rejections/Not Completes',
  },
  {
    label: 'Customer Request updates/objections',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Follow up on pending customer requests or objections',
  },
  {
    label: 'Metering service works',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Status updates/Rejections/Not Completes',
  },
  {
    label: 'Abolishment service order',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Status updates/Rejections/Not Completes',
  },
  {
    label: 'Tariff change',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Queries related to all network tariffs',
  },
  {
    label: 'Service charges including wasted visits',
    type: enquiryTypes[2],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Queries related to amounts charge and product codes',
  },
  {
    label: 'Re-energisation',
    type: enquiryTypes[3],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[2],
    email: enquiryEmails[6],
    description: 'Turn On for an established site',
  },
  {
    label: 'De-energisation',
    type: enquiryTypes[3],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[2],
    email: enquiryEmails[6],
    description: 'Turn Off for an established site',
  },
  {
    label: 'Special read',
    type: enquiryTypes[3],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[2],
    email: enquiryEmails[8],
    description: '',
  },
  {
    label: 'CES enquiry (off over 12 months only)',
    type: enquiryTypes[3],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[2],
    email: enquiryEmails[7],
    description: '',
  },
  {
    label: 'DLF/TNI',
    type: enquiryTypes[4],
    network: ['CitiPower'],
    team: enquiryTeams[0],
    email: enquiryEmails[3],
    description: '',
  },
  {
    label: 'DLF/TNI',
    type: enquiryTypes[4],
    network: ['Powercor'],
    team: enquiryTeams[0],
    email: enquiryEmails[4],
    description: '',
  },
  {
    label: 'Transfers / Change Requests',
    type: enquiryTypes[4],
    network: ['CitiPower'],
    team: enquiryTeams[0],
    email: enquiryEmails[3],
    description: 'Queries relating to transfer and change requests',
  },
  {
    label: 'Transfers / Change Requests',
    type: enquiryTypes[4],
    network: ['Powercor'],
    team: enquiryTeams[0],
    email: enquiryEmails[4],
    description: 'Queries relating to transfer and change requests',
  },
  {
    label: '',
    type: enquiryTypes[5],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[1],
    email: enquiryEmails[2],
    description: 'Enquiries related to embedded networks',
  },
  {
    label: 'CDN/SAN Rejection or Enquiry',
    type: enquiryTypes[6],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[2],
    email: enquiryEmails[8],
    description: 'CDN/SAN Rejection or Enquiry',
  },
  {
    label: '',
    type: enquiryTypes[7],
    network: ['CitiPower', 'Powercor'],
    team: enquiryTeams[2],
    email: enquiryEmails[2],
    description: '',
  },
];
